import React, { useContext, useEffect, useState } from "react";
import SessionContext from "SessionContext";
import { Card, CardBody } from "reactstrap";
import { chart_view_map } from "./index";
import { humanizeNumber } from './chart-base';
import { states as statesList } from "../../utils/list-of-states";


const PrintableChart = (props) => {
    const session = useContext(SessionContext);

    const [config, setConfig] = useState(null);
    const [values, setValues] = useState(null);
    const [uiType, setUiType] = useState(null);
    const [filters, setFilters] = useState(null);
    const [ViewComponent, setViewComponent] = useState(null);

    useEffect(() => {
        let _chart_id = props.chart_id;
        if(_chart_id) {
            session.crossfilterStore.chart_enter(_chart_id);
            setConfig(session.chartsStore.charts[_chart_id]);
            setValues(session.crossfilterStore['counts_filtered']);
            setFilters(session.crossfilterStore.filters[_chart_id] || []);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(config) {
            setUiType(config.uiType);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config])

    useEffect(() => {
        if(uiType) {
            if(uiType.includes("int-range")) {
                setViewComponent(() => chart_view_map["int-range"]);
            } else {
                setViewComponent(() => chart_view_map[uiType.trim()]);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uiType])

    useEffect(() => {
        if(config) {
            if(filters && filters[0] && filters[0].is_negated) {
                setConfig({...config, excluded: "excluded: "});
            } else {
                setConfig({...config, excluded: ""});
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters])

    if(!session.chartsStore.loaded) {
        return <>Loading Chart...</>;
    }

    if(!config) {
        return <></>;
    }

    let prefix = session.crossfilterStore.geoPrefix;

    /* for states widget: display a summary version */
    if(config.id === `${prefix}state`) {
      const xcounts = session.crossfilterStore['counts_filtered'][`xcounts__${prefix}geo.${prefix}state`];
      let _color = session.chartsStore.charts[`${prefix}state`].color;

      const selectedStates = new Set(filters.map(f => f.value));

      let final_list = statesList.map(_state => {
        const isSelected = selectedStates.has(_state.code);
        return {
          label: _state.code,
          value: xcounts[_state.code],
          color: isSelected ? 'white'  : _color,
          background: isSelected ? _color : 'white',
        };
      })

      final_list.sort((a, b) => {
        // selected states go first
        const aSelected = a.background !== 'white';
        const bSelected = b.background !== 'white';
        return (aSelected === bSelected) ? 0 : aSelected ? -1 : 1;
      });

      return (
        <Card className="view-only">
          <CardBody className="chart-card">
            <figure className="chart-widget is-view-only bar-chart count-widget">
                <figcaption className="heading" draggable="false">
                    <span>{config.excluded}{config.label}</span>
                    <i className="spacer"></i>
                </figcaption>

                <div className="chart-scrollwrap overflow-bottom expanded">
                  <div className="chart">
                        <ul>
                            {final_list.map((item) => {
                                return (
                                  <li key={item.label}>
                                    <div style={{ backgroundColor: item.background, color: item.color, margin: '5px 0' }} className="st-row-selected">
                                        <span className="inner">{item.label}</span>
                                        <span className="count">{humanizeNumber(item.value)}</span>
                                    </div>
                                  </li>)
                            })}
                        </ul>
                  </div>
                </div>
            </figure>
          </CardBody>
        </ Card>
      )      
    }

    return (
        <Card className="view-only">
          <CardBody className="chart-card">
              {ViewComponent && (
                <ViewComponent 
                  config={config} 
                  filters={filters} 
                  values={values} 
                  className='is-view-only' 
                  viewOnly={true} 
                  expandedView={true} 
                  loaded={true}
                  followCursor={true}
                />
              )}
         </CardBody>
        </Card>
    )

}

export default PrintableChart;


